<template>
    <div>
        <!-- PC 리드워크 아웃소싱 프로세스  -->
        <div class="w-full h-[496px] mx-auto hidden lg:flex flex-col pt-10 items-center">
            <p class="font-bold text-medium-size-0 text-text-0 tracking-[-0.0045em]">개발 아웃소싱 프로세스</p>
            <!-- <p class="text-text-1 text-medium-size-1 tracking-[-0.0045em] mt-5 lg:px-[60px] text-center">리드워크만의 QA 3S 시스템을 통해 높은 경쟁력과 안정적 프로젝트 수행을 약속합니다.</p> -->
            <div class="flex mt-[60px] w-full items-center">
                <template v-for="(step, index) in steps" :key="index">
                    <div class="flex items-center" :class="index < steps.length - 1 ? 'flex-1' : ''">
                        <div
                            class="w-[200px] h-[200px] bg-main-2 text-[24px] font-medium rounded-full flex items-center justify-center text-white text-center flex-shrink-0"
                            v-html="step.pcText">
                        </div>
                        <div v-if="index < steps.length - 1" class="flex-1 h-1 bg-main-2 min-w-[20px]"></div>
                    </div>
                </template>
            </div>
        </div>

        <!-- 모바일 리드워크 아웃소싱 프로세스 -->
        <div
            class="flex flex-col items-center justify-center px-5 py-10 mx-auto bg-[#F3FAF9] lg:hidden">
            <p class="font-bold text-text-0 text-medium-size-2 text-center tracking-[-0.0045em] mb-5">
                개발 아웃소싱 프로세스
            </p>
            <!-- <p class="text-text-1 text-center px-5 break-keep">
                리드워크만의 QA 3S 시스템을 통해 높은 경쟁력과 안정적 프로젝트 수행을 약속합니다.
            </p> -->

            <div class="flex mt-10 w-full items-center justify-center gap-0">
                <div v-for="(step, index) in steps" :key="index" class="flex-1 flex items-center justify-center">
                    <div
                        class="aspect-square w-full bg-main-2 text-[2.5vw] rounded-full flex items-center justify-center text-white font-medium text-center leading-tight px-1"
                        v-html="step.mobileText">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OutsourcingProcess',
    data() {
        return {
            steps: [
                {
                    pcText: '프로젝트 의뢰',
                    mobileText: '프로젝트<br/>의뢰'
                },
                {
                    pcText: '기획 구조 협의 및<br/>기술 검토',
                    mobileText: '기획 구조<br/>협의 및<br/>기술 검토'
                },
                {
                    pcText: '공수 산정 및 견적',
                    mobileText: '공수 산정<br/>및 견적'
                },
                {
                    pcText: '개발 계약 체결',
                    mobileText: '개발 계약<br/>체결'
                },
                {
                    pcText: '엔지니어 투입 및<br>개발 수행',
                    mobileText: '엔지니어<br/>투입 및<br/>개발 수행'
                }
            ]
        }
    }
}
</script>
